import useSound from 'use-sound'
import deal from 'lib/assets/audio/deal.mp3'
import clear from 'lib/assets/audio/clear.mp3'
import raise from 'lib/assets/audio/raise.mp3'
import rebet from 'lib/assets/audio/rebet.mp3'
import undo from 'lib/assets/audio/undo.mp3'
import fold from 'lib/assets/audio/fold.mp3'
import newBet from 'lib/assets/audio/newbet.mp3'

export const useButtonSounds = (audio: any) => {
    const [playClearSFX] = useSound(clear, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playDealSFX] = useSound(deal, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playRaiseSFX] = useSound(raise, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playRebetSFX] = useSound(rebet, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playUndoSFX] = useSound(undo, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playFoldlSFX] = useSound(fold, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })
    const [playnewBetSFX] = useSound(newBet, {
        volume: audio?.volume ? parseFloat(audio.volume) : 0,
    })

    return {
        playDealSFX,
        playRaiseSFX,
        playRebetSFX,
        playUndoSFX,
        playFoldlSFX,
        playnewBetSFX,
        playClearSFX
    }
}